import { Button, Form, Image, Select } from "antd"
import AdminLayout from "../adminLayout"
import ResetConfirmModal from "components/ResetConfirmModal"
import "./style.scss"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { adminLogoutAction } from "store/sagas/adminAuthSaga"
import { AdminLogoutParams } from "types/auth"
import { useState } from "react"
import { SelectOption } from "types/asset"

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
}
const Reset = () => {
  const [form] = Form.useForm()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const getSelectedId = () => {
    const selectedId = localStorage.getItem("selected_reset")
    const selectedName = localStorage.getItem("selected_reset_name")
    if (selectedId && selectedName) {
      return {
        value: Number(selectedId),
        label: selectedName,
      }
    }
    return {
      value: "all",
      label: "全て",
    }
  }
  const selectList = [
    { value: "all", label: "全て" },
    { value: "user", label: "従業員" },
    { value: "line", label: "ライン" },
    { value: "product", label: "機種" },
    { value: "process", label: "工程" },
  ]
  const [selected, setSelected] = useState<SelectOption>(() => getSelectedId())
  const [isOpenConfirmModal, setIsOpenConfirmModal] = useState(false)

  const handleSelect = (value: any, option: SelectOption) => {
    setSelected(option)
  }

  const handleLogout = () => {
    const data: AdminLogoutParams = {
      logout_type: "primary",
    }
    dispatch(adminLogoutAction(data))
    localStorage.removeItem("selected_reset")
    localStorage.removeItem("selected_reset_name")
    navigate("/admin/login")
  }

  return (
    <>
      <AdminLayout>
        <div className="setting-form">
          <Form {...layout} form={form} name="nest-messages">
            <p className="title-reset mb-3">リセット対象選択</p>
            <Form.Item name="resetType">
              <div>
                <Select
                  defaultValue={selected?.label || -1}
                  className="select-reset"
                  options={selectList}
                  suffixIcon={
                    <Image
                      preview={false}
                      src="https://i.imgur.com/0mU6EI5.png"
                    />
                  }
                  onSelect={handleSelect}
                />
              </div>
            </Form.Item>

            <div>
              <div className="flex items-center justify-center mt-5">
                <Button
                  className="button-reset font-noto-sans text-[16px] not-italic font-bold"
                  onClick={() => setIsOpenConfirmModal(true)}
                >
                  リセット
                </Button>
              </div>
            </div>
            <div className="flex items-center justify-center mt-10">
              <Button
                className="button-reset bt-return font-noto-sans text-[16px] not-italic font-bold"
                onClick={handleLogout}
              >
                戻る
              </Button>
            </div>
          </Form>
        </div>
      </AdminLayout>
      <ResetConfirmModal
        open={isOpenConfirmModal}
        setOpen={setIsOpenConfirmModal}
        resetType={selected.value.toString()}
        resetTypeLabel={selected.label}
      />
    </>
  )
}
export default Reset
